// extracted by mini-css-extract-plugin
export default {"root":"_2sD0J","large":"_2nQJH","hoverable":"_27_IL","medium":"Cs1sZ","small":"_2QMDv"};